import { useParams } from "react-router-dom";

const LEGACY_PAGES = {
  cgu: { title: "Conditions Générales d'Utilisation", src: "/content/cgu.html" },
  privacy: { title: "Politique de Confidentialité", src: "/content/privacy.html" },
} as const;

type LegalPageConfig = { title: string; src: string };

function resolveLegalPage(type: string | undefined): LegalPageConfig | null {
  if (!type) return null;

  if (type in LEGACY_PAGES) {
    return LEGACY_PAGES[type as keyof typeof LEGACY_PAGES];
  }

  const versioned = type.match(/^(cgu|privacy)-v(\d+)$/);
  if (!versioned) return null;

  const [, docType, version] = versioned;
  const titles: Record<string, string> = {
    cgu: "Conditions Générales d'Utilisation",
    privacy: "Politique de Confidentialité",
  };

  return {
    title: `${titles[docType]} (v${version})`,
    src: `/content/${docType}-v${version}.html`,
  };
}

export default function LegalPage() {
  const { type } = useParams<{ type: string }>();
  const page = resolveLegalPage(type);

  if (!page) return null;

  return (
    <div className="flex flex-col h-screen bg-background">
      <header className="flex items-center gap-3 border-b px-4 py-3">
        <h1 className="text-sm font-medium text-foreground">{page.title}</h1>
      </header>
      <iframe
        src={page.src}
        title={page.title}
        className="flex-1 w-full border-0"
      />
    </div>
  );
}
